import useTranslations from '@/i18n/useTranslations';
import FormError from '@/shared-components/error/components/FormError';
import PublicFormInput from '@/shared-components/inputs/components/PublicFormInput';

import './styles/PersonalizedTime.css';

export default function PersonalizedTime({ formState, setFormState, error }) {
  const t = useTranslations('common.profile.pages.artlist');

  function updateFormState(key, value) {
    setFormState({
      ...formState,
      [key]: value
    });
  }

  return (
    <>
      <div className={`personalized-time__container ${formState.time_selected === "personalized" ? "expanded" : ""}`}>
        <PublicFormInput 
          placeholder={t('time_selector.fields.personalized_quantity')} 
          element="time_quantity" 
          type="number"
          value={formState.time_selected === "personalized" ? formState.time_quantity : ""}
          onChange={(e) => updateFormState("time_quantity", e.target.value)}
        />
                
        <PublicFormInput 
          placeholder={t('time_selector.fields.time_unit')} 
          element="time_unit"
          type="select" 
          selectOptions={{
            options: [
              { label: t('time_selector.units.seconds'), value: "seconds" },
              { label: t('time_selector.units.minutes'), value: "minutes" },
              { label: t('time_selector.units.hours'), value: "hours" },
            ],
          }}
          value={formState.time_selected === "personalized" ? (formState.time_unit || "seconds") : ""}
          onChange={newValue => updateFormState("time_unit", newValue)}
        />

      </div>

      <FormError error={error} element="time_quantity"/>
    </>
  );
}
